<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Números Proibidos</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Controle números bloqueados para impedir contatos indevidos nas operações dos operadores.</p>
        </div>

        <button
          type="button"
          class="icon-anim-trigger--back group flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md sm:w-auto"
          @click="voltarParaOperadores"
        >
          <svg class="icon-anim icon-anim--back h-5 w-5 text-gray-500 group-hover:text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          Voltar
        </button>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm md:p-5">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div class="flex flex-col gap-1 md:col-span-2">
            <label class="text-sm font-medium text-gray-500"> Número ou observação </label>
            <input
              v-model="filtroBusca"
              type="text"
              placeholder="Ex: 11999999999"
              class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div class="flex items-end gap-2 md:col-span-1">
            <button @click="aplicarFiltros" type="button" class="h-11 w-full rounded-xl bg-blue-500 font-medium text-white transition hover:bg-blue-600">Buscar</button>
            <button @click="limparFiltros" type="button" class="h-11 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 transition hover:bg-gray-50">Limpar</button>
          </div>
        </div>
      </div>

      <div class="mb-4 flex flex-col gap-3 sm:flex-row sm:justify-end">
        <button type="button" class="flex w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-2.5 shadow-sm transition hover:shadow-md sm:w-auto" @click="baixarNumerosProibidos">
          <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-4-4m4 4 4-4M5 21h14" />
          </svg>
          <span class="text-sm font-medium text-gray-700">Download</span>
        </button>

        <button type="button" class="flex w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-2.5 shadow-sm transition hover:shadow-md sm:w-auto" @click="irParaNovoNumeroProibido">
          <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          <span class="text-sm font-medium text-gray-700">Novo número</span>
        </button>
      </div>

      <div class="w-full overflow-hidden rounded-[28px] border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Número</th>
                <th class="px-6 py-4 text-left font-medium">Observação</th>
                <th class="px-6 py-4 text-left font-medium">Cadastro</th>
                <th class="px-6 py-4 text-center font-medium">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in numerosPaginados" :key="item._id" class="border-b border-gray-100 transition hover:bg-slate-50">
                <td class="px-6 py-5 font-medium text-gray-800">{{ item.numero }}</td>
                <td class="px-6 text-gray-700">{{ item.observacao || "-" }}</td>
                <td class="px-6 text-gray-700">{{ formatDate(item.dataInclusao) }}</td>
                <td class="px-6 py-5">
                  <div class="flex flex-wrap justify-center gap-2">
                    <button type="button" class="rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-600">Editar</button>
                    <button type="button" class="rounded-lg bg-red-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-800" @click="removerNumero(item._id)">Remover</button>
                  </div>
                </td>
              </tr>

              <tr v-if="numerosPaginados.length === 0">
                <td colspan="4" class="px-6 py-12 text-center text-sm text-gray-400">Nenhum número encontrado com os filtros atuais.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <AppPagination :current-page="paginaAtual" :total-pages="totalPaginas" :total-items="numerosFiltrados.length" :page-size="itensPorPagina" item-label="números" @paginate="setPage" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppPagination
  },
  data() {
    return {
      filtroBusca: "",
      paginaAtual: 1,
      itensPorPagina: 5,
      numeros: [],
      moment,
      carregando: false
    };
  },
  computed: {
    numerosFiltrados() {
      const busca = this.filtroBusca.trim().toLowerCase();
      if (!busca) {
        return this.numeros;
      }

      return this.numeros.filter((item) => {
        const numero = String(item.numero || "").toLowerCase();
        const observacao = String(item.observacao || "").toLowerCase();
        return numero.includes(busca) || observacao.includes(busca);
      });
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.numerosFiltrados.length / this.itensPorPagina));
    },
    numerosPaginados() {
      const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.numerosFiltrados.slice(inicio, inicio + this.itensPorPagina);
    }
  },
  methods: {
    formatDate(dateValue) {
      return dateValue ? this.moment(dateValue).format("DD/MM/YYYY HH:mm") : "";
    },
    async carregarNumeros() {
      this.carregando = true;
      try {
        const response = await this.$http.post("/v1/numeros-proibidos/list", {
          all: true
        });
        const lista = response?.data?.data || [];

        this.numeros = lista;
        this.paginaAtual = 1;
      } catch (error) {
        console.error(error);
        this.$vToastify.error("Erro ao carregar números proibidos");
      } finally {
        this.carregando = false;
      }
    },
    aplicarFiltros() {
      this.paginaAtual = 1;
    },
    limparFiltros() {
      this.filtroBusca = "";
      this.paginaAtual = 1;
    },
    setPage(page) {
      this.paginaAtual = page;
    },
    voltarParaOperadores() {
      this.$router.push({ name: "Operadores" });
    },
    irParaNovoNumeroProibido() {
      this.$router.push({ name: "NovoNumeroProibido" });
    },
    async baixarNumerosProibidos() {
      try {
        const response = await this.$http.get("/v1/numeros-proibidos/downloadCSV", {
          responseType: "blob"
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `numeros-proibidos-${new Date().toISOString().split("T")[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        this.$vToastify.error("Erro ao exportar os números");
      }
    },
    async removerNumero(id) {
      if (!confirm("Tem certeza que deseja excluir esse número?")) {
        return;
      }

      try {
        const resp = await this.$http.delete(`/v1/numeros-proibidos/${id}`);
        if (!resp.data.success) {
          this.$vToastify.error(resp.data.err || "Erro ao remover número");
          return;
        }

        this.$vToastify.success("Número removido");
        await this.carregarNumeros();
      } catch (error) {
        console.error(error);
        this.$vToastify.error("Erro ao remover número");
      }
    }
  },
  async beforeMount() {
    await this.carregarNumeros();
  }
};
</script>

<style scoped></style>
